import axios from "axios";

const apiClient = axios.create({
  baseURL: process.env.REACT_APP_API_URL || "http://localhost:8000/api",
});

apiClient.interceptors.request.use((config) => {
  const user = JSON.parse(localStorage.getItem("user"));
  if (user?.token) {
    config.headers.Authorization = `Bearer ${user.token}`;
  }
  return config;
});

export const followApi = {
  /**
   * FOLLOW USER
   * Endpoint: POST /api/follow/:userId
   * ⚠️ IMPORTANT: NOT /api/users/:userId/follow (that returns 404!)
   */
  followUser: async (userId) => {
    return apiClient.post(`/follow/${userId}`);
  },

  /**
   * UNFOLLOW USER
   * Endpoint: DELETE /api/follow/:userId
   */
  unfollowUser: async (userId) => {
    return apiClient.delete(`/follow/${userId}`);
  },

  /**
   * CHECK IF FOLLOWING
   * Endpoint: GET /api/follow/:userId/check
   */
  checkFollowing: async (userId) => {
    return apiClient.get(`/follow/${userId}/check`);
  },

  /**
   * GET USER'S FOLLOWERS
   * Endpoint: GET /api/follow/:userId/followers
   */
  getFollowers: async (
    userId,
    { page = 1, limit = 20, cursor = null } = {}
  ) => {
    return apiClient.get(`/follow/${userId}/followers`, {
      params: { page, limit, cursor },
    });
  },

  /**
   * GET USER'S FOLLOWING
   * Endpoint: GET /api/follow/:userId/following
   */
  getFollowing: async (
    userId,
    { page = 1, limit = 20, cursor = null } = {}
  ) => {
    return apiClient.get(`/follow/${userId}/following`, {
      params: { page, limit, cursor },
    });
  },

  /**
   * GET MUTUAL FOLLOWS
   * Endpoint: GET /api/follow/:userId/mutual
   */
  getMutualFollows: async (userId) => {
    return apiClient.get(`/follow/${userId}/mutual`);
  },
};

export default followApi;
